import { doc, getDoc, setDoc, increment } from "firebase/firestore";
import { db } from "../firebase/config";

const SUMMARY_DOC = "payroll";

/**
 * Get the payroll approval summary for a company.
 * Returns { pendingApproval, updatedAt } or default zero.
 *
 * Adapted from otApprovalSummaryService.js. Drives the dashboard card
 * and sidebar badge count for pending payroll approvals.
 * See PRD_PayrollApproval.md §Data Model.
 */
export const getPayrollApprovalSummary = async (companyId) => {
  const ref = doc(db, "companies", companyId, "summaries", SUMMARY_DOC);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    return snap.data();
  }

  return { pendingApproval: 0 };
};

/**
 * Update the pendingApproval counter atomically.
 *
 * @param {string} companyId
 * @param {number} delta - +1 on Submit, -1 on Approve or Reject
 */
export const incrementPendingApproval = async (companyId, delta) => {
  const ref = doc(db, "companies", companyId, "summaries", SUMMARY_DOC);
  await setDoc(
    ref,
    {
      pendingApproval: increment(delta),
      updatedAt: new Date(),
    },
    { merge: true }
  );
};
